const ROUTES = {
  MAIN: '/',
  OSCE: {
    STATS: '/osce/stats',
    SESSIONS: '/osce/sessions',
    SESSION_DETAIL: '/osce/sessions/:id',
    STATS_DETAIL_LEGACY: '/osce/stats/:id',
    CALCULATOR: '/osce/calculator',
    STATIONS: '/osce/stations',
  },
  TUTOR: {
    STATS: '/tutor/dashboard',
    SESSIONS: '/tutor/sessions',
    SESSION_DETAIL: '/tutor/sessions/:id',
  },
  SSO: {
    DASHBOARD: '/sso',
    DETAIL: '/sso/:id',
  },
  UNIVERSITY_ACCOUNTS: {
    LIST: '/university-accounts',
    DETAIL: '/university-accounts/:id',
  },
  STUDY_GROUP: {
    GROUPS: '/study-group/groups',
    GROUP_DETAIL: '/study-group/groups/:id',
    SETTINGS: '/study-group/settings',
  },
  SETTINGS: {
    PROMPTS: '/settings/prompts',
  },
  ASSET: {
    VIDEO: {
      MAIN: '/asset/video/manage',
    },
    IMAGE: {
      MAIN: '/asset/image/manage',
    },
    AWS: {
      MAIN: '/asset/aws/manage',
    },
  },
  AI: {
    HIGH_YIELD: '/ai/high-yield',
    PROMPT_LAB: '/ai/prompt-lab',
  },
  CONTENT: {
    DELETE: {
      MAIN: '/content/delete',
    },
    EDIT: {
      QUESTION: '/content/edit/question/:id',
      CHAPTER: '/content/edit/chapter',
      STATION: '/content/edit/station/:id',
    },
    VALIDATE: {
      QUESTION: '/content/validate/question',
      STATION: '/content/validate/station',
      MOCK_TEST: '/content/validate/mock-test',
      BOOK: '/content/validate/book',
      UCAT: '/content/validate/ucat',
    },
    TEMPLATE: '/content/template',
    CLONE: '/content/clone',
    BATCH: {
      PUBLIC: '/content/batch/public',
      IMPORT: '/content/batch/import',
      OVERWRITE: '/content/batch/overwrite',
    },
    JOB: {
      LIST: '/content/job/list',
      DETAIL: '/content/job/detail/:id',
      CREATE: '/content/job/create',
      EXAMPLE: '/content/job/example',
    },
    BLOG: {
      MAIN: '/content/blog',
    },
    REVIEW: {
      COMMENTS: '/content/review/comments',
      QUESTIONS: '/content/review/questions',
      WEEKLY_SEARCH: '/content/review/weekly-search',
      WEEKLY_SQL_VIEW: '/content/review/weekly-sql-view',
      QUERIES: '/content/review/queries',
    },
  },
  ALGOLIA: {
    MAIN: '/algolia/re-index',
  },
  SENDGRID: {
    MAIN: '/sendgrid/sync-contact',
  },
  USER: {
    SESSIONS: '/user/sessions',
    INFO: '/user/info',
    SUBS: '/user/subs',
  },
  DATABASE: {
    NOTIFICATION: '/database/notification',
    REFRESH_MTV: '/database/refresh-mtv',
    CRON: '/database/cron',
    CACHE: '/database/cache',
  },
  SUBSCRIPTION: {
    TRANSACTIONS: '/subscription/transactions',
    REVIEWS: '/subscription/reviews',
  },
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  TEMP: '/temp',
};

const publicRoutes: string[] = [ROUTES.LOGIN, ROUTES.REGISTER, ROUTES.TEMP];

export { publicRoutes, ROUTES };
